<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.txt-color{
  word-break: keep-all;
}
.row-import {
  display: flex;
  margin-bottom: 20px;
  margin-left: 18px;
}
.row-import .left {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  padding-top: 4px;
}
.row-import .right {
  font-size: 14px;
}
.tipInfo {
  margin-top: 10px;
  color: #646464;
  line-height: 30px;
}

.el-col-8{
  display: flex;
  /* margin-bottom: 15px; */
}
.ipt-sty{
  flex: 1;
}
.reject-btn.btn {
  background: #FFF2F4;
  border: 1px solid rgba(255, 219, 224, 1);
  border-radius: 2px;
  color: #FB2323;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;

}

.pass-btn.btn {
  background: #F2FFF5;
  border: 1px solid rgba(220, 250, 228, 1);
  border-radius: 2px;
  color: #1BA854;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.ing-btn.btn {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 2px;
  color: #FF991C;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}

.cancel-btn.btn {
  background: #F5F5F5;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  color: #666;
  font-size: 12px;
  width: 44px;
  height: 22px;
  display: inline-block;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">委托方</div>
          <el-select
            @change="handleChangeCompany"
            v-model="page.tenantGuid"
            placeholder="请选择委托方"
            class="ipt-sty"
            filterable
            size="mini"
          >
            <el-option
              v-for="(item,index) in sendTenantList"
              :key="index"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            ></el-option> </el-select
        ></el-col>
        <el-col :span="6"
          ><div class="search-area-div">执行部门</div>
          <el-select
            v-model="page.organisationInfo"
            filterable
            placeholder="请选择执行部门"
            class="ipt-sty"
            size="mini"
          >
            <el-option
              v-for="(item,index) in organisationList"
              :key="index"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">执行时间</div>
          <el-date-picker
            class="ipt-sty"
            size="mini"
            v-model="timeRange"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="截止时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">审批状态</div>
          <el-select  size="mini" v-model="page.approvalState" filterable placeholder="请选择执行状态" class="ipt-sty" >
            <el-option v-for="item in approvalStateList" :key="item.value" :label="item.label" :value="item.value"></el-option> </el-select
        ></el-col>
        <el-col :span="6">
          <div class="search-area-div">任务标题</div>
          <el-input placeholder="请填写任务标题"  class="ipt-sty"  size="mini" v-model="page.taskTitle"></el-input>
         </el-col>
         <el-col :span="6">
          <div class="search-area-div">提交人</div>
          <el-input type="text" size="mini" class="ipt-sty"  placeholder="请输入提交人"   v-model="page.staffName"></el-input>
        </el-col>
        
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <el-table :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading" @sort-change="sortChange">
        <el-table-column label="序号" fixed="left" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column fixed="left" prop="createUserName" width="320" label="任务标题" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.taskTitle || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" label="提交人" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.bizApproveVO.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="审批状态" header-align="center" align="center">
          <template slot-scope="scope" >
            <div v-if="scope.row.bizApproveVO">
              <a class="reject-btn btn" v-if="scope.row.bizApproveVO.approveState == 'R'">已驳回</a>
              <a class="pass-btn btn" v-if="scope.row.bizApproveVO.approveState == 'Y'">已通过</a>
              <a class="ing-btn btn" v-if="scope.row.bizApproveVO.approveState == 'A'">审批中</a>
              <a class="cancel-btn btn" v-if="scope.row.bizApproveVO.approveState == 'C'">已撤销</a>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="tenantName"
          show-overflow-tooltip
          min-width="140"
          label="委托方"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="serviceTenantName"
          show-overflow-tooltip
          min-width="240"
          label="服务商"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{scope.row.isChangeService=='Y'?scope.row.newServiceTenantName:scope.row.serviceTenantName}}</template>
        </el-table-column>
        <el-table-column
          prop="campaignsState"
          min-width="180"
          show-overflow-tooltip
          label="执行部门"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ getDepartmentName(scope.row.organisationInfo||scope.row.oldOrganisationInfo)}}</template>
        </el-table-column>

        <el-table-column prop="campaignsState" width="210" label="执行时间" header-align="center" align="center">
          <template slot-scope="scope"
            >{{ scope.row.startTime | getDate }} 至 {{
            scope.row.endTime | getDate
          }}</template
          >
        </el-table-column>
        <el-table-column prop="createUserName" width="96" show-overflow-tooltip label="任务名称" header-align="center" align="left">
          <template slot-scope="scope">共{{ scope.row.taskDetailCount }}项目</template>
        </el-table-column>
        <el-table-column
          prop="state"
          show-overflow-tooltip
          :render-header="renderHeader"
          width="110"
          label="任务包状态"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.state }}</template>
        </el-table-column>
        <el-table-column prop="timeState" width="96" label="业务执行状态" header-align="center" align="left" >
          <template slot-scope="scope">{{ scope.row.timeState }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createUserName" width="96" label="完成状态" header-align="center" align="left" >
          <template slot-scope="scope">{{ scope.row.finishState }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" width="110" label="成果上传状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.uploadState }}</template>
        </el-table-column>
        <el-table-column prop="createUserName" width="96" label="结算状态" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.payState }}</template>
        </el-table-column> -->
        <el-table-column  prop="taskNo" width="120" label="任务包编号" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.taskNo }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a @click="passDialogVisible = true; detail = scope.row.bizApproveVO; approveSuggest = ''" class="txt-color"
                v-if="scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1">通过｜</a>
              <a class="txt-color" @click="rejectDialogVisible = true; detail = scope.row.bizApproveVO; approveSuggest = ''"
                v-if="scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1">驳回｜</a>
              <a class="txt-color" @click=toRevoke(scope.row.bizApproveVO)
                v-if="scope.row.bizApproveVO && scope.row.bizApproveVO.approveState == 'A' && scope.row.bizApproveVO.staffGuid == staffGuid"
               >撤销｜</a>
            <a
              class="txt-color"
              v-loading.fullscreen.lock="fullscreenLoading"
              @click="toDeal(scope.row)"
              >任务详情
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,50,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea"  maxlength="100" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info"  class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea"  maxlength="100" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      staffGuid: userinfo.staffGuid,

      showMore: false,// 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 210,
      contentMainHeight: window.innerHeight - 200,
      guid:'',
      fileList:[],
      visible6:false,
      fullscreenLoading: false,
      textTitle: '配置任务包',
      stateList: ['待派发', '已派发', '待上传', '待考核', '已失效', '待结算', '已完结'],
      timeStateList: ['未开始', '进行中', '已结束'],
      approvalStateList: [{
        label: '全部',
        value: '-1'

      },{
        label: '审批中',
        value: 'A'

      }, {
        label: '已通过',
        value: 'Y'

      }, {
        label: '已驳回',
        value: 'R'

      },
      {
        label: '已撤销',
        value: 'C'

      }],
      tenantList: [],
      organisationList: [],
      timeRange: '',
      page: {
        staffGuid:userinfo.staffGuid,
        serviceTenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '',
        timeState: '',
        flowType:['00015'],
        approvalState:'-1',
        taskTitle:'',
        flowType:['00015'],
        staffName:''
      },
      right: 'right',
      tableData: [],
      sendTenantList: [],
    };
  },
  created() {
    // notifyType	 1控销   2任务包   notifyPartyGuid staffGuid
    this.page.state = this.$route.query.state;
    // this.getTenantList();
    this.getSendTenantList();
    this.getList();
  },
  activated() {
    this.getList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 260;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 213;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  methods: {
    //排序
    sortChange(column) {
      console.log(column)
      if (column.prop == "tenantName"&&column.order) {
        this.page.orderColumn = 'tenant_name'
      } else if (column.prop == "serviceTenantName"&&column.order){
        this.page.orderColumn = 'service_tenant_name'
      }else{
        this.page.orderColumn = '';
      }
      this.getList()// 查询列表方法
    },
    getDepartmentName(list) {
      if (typeof list == 'string') {
        list = JSON.parse(list);
      }
      let personArr = [];
      let personTip = '';
      let departmentArr = [];
      let departmentTip = '';
      let personNum = 0;
      let departmentNum = 0;
      if (list && list.length > 0) {
        list.forEach(i => {
          if (i.objectType == '人员') {
            personArr.push(i.organisationName || i.name);
            personNum = personNum + 1;
          } else {
            departmentNum = departmentNum + 1;
            departmentArr.push(i.organisationName || i.name);
          }
        });
      }
      personTip =
        personArr.length > 2
          ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
          : personArr.splice(0, 2).join('、');
      console.log(personArr);
      departmentTip =
        departmentArr.length > 2
          ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
          : departmentArr.splice(0, 2).join('、');
      return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
    }, 
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      if (self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0] + ' ' + '00:00:00';
        self.page.endTime = self.timeRange[1] + ' ' + '23:59:59';
      }
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待派发', '已派发', '待上传', '待考核', '已失效', '待结算', '已完结'];
      req.approvalState = req.approvalState&& req.approvalState!='-1'?[req.approvalState]:null;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-flow-approve/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      var req = JSON.parse(JSON.stringify(this.page));
      req.state = req.state ? [req.state] : ['待派发', '已派发', '待上传', '待考核', '已失效', '待结算', '已完结'];
      req.approvalState = req.approvalState&& req.approvalState!='-1'?[req.approvalState]:null;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-flow-approve/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['010201', '0101'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid:localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        }
      });
    },
    emptySearch() {
      let userinfo = JSON.parse(localStorage.userInfo);
      this.page = {
        staffGuid:userinfo.staffGuid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        organisationInfo: '',
        startTime: '',
        endTime: '',
        state: '',
        timeState: '',
        serviceTenantGuid: localStorage.guid,
        flowType:['00015'],
        approvalState:'-1',
        taskTitle:'',
        staffName:''
      };
      this.organisationList = [];
      this.timeRange = '';
      this.getList();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    toDeal(detail) {
      this.$router.push('/taskDeliverModifyFlow01?guid=' + detail.guid+'&approveGuid='+detail.bizApproveVO.approveGuid+'&productGuid='+this.$route.query.productGuid); //去处理
    },
     //驳回提交
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.detail.approveGuid,
        flowType: '00015',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let query = {
        guid: this.detail.approveGuid,
        flowType: '00015',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤回
    toRevoke(detail) {
      let self = this;
      this.$confirm('撤销后，该流程将不再进行审核，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: detail.approveGuid,
          flowType: '00015',
          approveStaffGuid: this.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            this.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
   
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '1、草稿中：任务处于待编辑状态，提交后才能发布；',
                 h('br'),
                '2、待发布：需要企业人员确认任务包是否发布；',
                h('br'),
                '3、待受理：需要代运营人员在运营平台进行受理并分解任务包；',
                h('br'),
                '4、待派发：需要代运营人员进行任务的下发；',
                h('br'),
                '5、已派发：指任务已下发给业务员；',
                h('br'),
                '6、待上传：需要代运营人员进行运营成功报告的上传；',
                h('br'),
                '7、待考核：由药企人员确认任务成果，并确认；',
                h('br'),
                '8、待结算：需要企业进行与运营公司的结算，并上传结算凭证；',
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.search-area-div{
  width:60px;
}
.el-col-6{
  display: flex;
}
 .el-col-8{
  display: flex;
}
</style>